/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc
 */

export const inviteUserRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'inviteUser',
  auth: 'external',
  fingerprint: 'NL05okFZSpQKu6jTTwWasL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const acceptInvitationRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'acceptInvitation',
  auth: 'external',
  fingerprint: 'cZx62JgBWbVl2Y50fi73eb5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listUserInvitationsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'listUserInvitations',
  auth: 'external',
  fingerprint: 'Vic9PHo2l_IvwwYD3cLCeL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninviteUserRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'uninviteUser',
  auth: 'external',
  fingerprint: 'wVJDNzQRKg20nC25eJ-tVL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const changeUserRoleRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'changeUserRole',
  auth: 'external',
  fingerprint: '9Ggg38fRYau5VMyrzsrZfb5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};